import {
  Button,
  HStack,
  Icon,
  StackProps,
  Text,
  VStack,
} from "@chakra-ui/react";
import { RiArrowRightDoubleLine } from "@remixicon/react";
import { useNavigate } from "react-router-dom";
import { OrderStatusInterface } from "../../constants/OrderStatus";
import { useBgHover, useDarkWhiteColor } from "../../themes/colors";
import { Empty } from "../card/Empty";
import { OrderStatusCard } from "../card/OrderStatusCard";

interface Props extends StackProps {
  data: OrderStatusInterface[] | undefined;
  pageType?: number;
}

export const RecentOrder = ({ data, pageType = 2, ...rest }: Props) => {
  const bgBnw = useDarkWhiteColor();
  const bgHover = useBgHover();
  const navigate = useNavigate();

  const goToOrderStatus = () => {
    let userType: string = "buyer";

    if (pageType === 2) {
      userType = "reseller";
    } else if (pageType === 3) {
      userType = "supplier";
    }

    navigate(`/${userType}/order`);
  };

  return (
    <VStack
      w={"100%"}
      minWidth="300px"
      height={"100%"}
      minH={"390px"}
      maxH={"390px"}
      bg={bgBnw}
      borderRadius={"md"}
      align={"stretch"}
      gap={4}
      overflowY={"hidden"}
      {...rest}
    >
      <HStack w={"100%"} pt={4} pl={4} pr={4} justify={"space-between"}>
        <Text textStyle={"h-reg-title"}>Penjualan Terbaru</Text>

        <Button
          variant={"ghost"}
          colorScheme="red"
          rightIcon={<Icon as={RiArrowRightDoubleLine} />}
          onClick={goToOrderStatus}
        >
          Lihat Semua
        </Button>
      </HStack>

      <VStack w={"100%"} overflowY={"auto"}>
        {data && data.length < 1 ? (
          <Empty alignSelf={"center"} title="Belum ada barang terjual" />
        ) : (
          data &&
          data.map((item) => (
            <OrderStatusCard
              key={item.id}
              item={item}
              pageType={pageType}
              _hover={{ bg: bgHover }}
            />
          ))
        )}
      </VStack>
    </VStack>

    // <TableContainer
    //   className="table-recent-order"
    //   w={"100%"}
    //   fontSize={[12, null, 14]}
    //   {...rest}
    // >
    //   <Table variant={"striped"} colorScheme="red">
    //     <Thead>
    //       <Tr>
    //         <Th>No.</Th>
    //         <Th>Image</Th>
    //         <Th>Name</Th>
    //         <Th>Reseller</Th>
    //         <Th>Status Pesanan</Th>
    //         {/* Sticky "Tanggal Pesanan" Column */}
    //         <Th>Tanggal Pesanan</Th>
    //         <Th position="sticky" right={0} zIndex={2} bg="white">
    //           Aksi
    //         </Th>
    //       </Tr>
    //     </Thead>
    //     <Tbody>
    //       {data?.map((item, index) => (
    //         <Tr key={item.id}>
    //           <Td>{index + 1}</Td>
    //           <Td>{item.img}</Td>
    //           <Td>{item.name}</Td>
    //           <Td>{item.reseller}</Td>
    //           <Td>{item.statusOrder}</Td>
    //           {/* Sticky "Tanggal Pesanan" Cell */}
    //           <Td>{formatDate(item.orderDate.toString())}</Td>
    //           <Td position="sticky" right={0} zIndex={1} bg="white">
    //             <Button colorScheme="blue">{`Detail >>`}</Button>
    //           </Td>
    //         </Tr>
    //       ))}
    //     </Tbody>
    //   </Table>
    // </TableContainer>
  );
};
